// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1__fd29791e9ef896086b99","cls2":"Unibrow-cls2__fbfa890798801fee3220 Unibrow-cls1__fd29791e9ef896086b99"};